<template>
<div>
    <div class="row d-flex align-items-center justify-content-center">
        <div class="col-10">
            <Button @click="$router.go(-1)" size="small" type="outline" color="grey">
                <ArrowDropdown :rotate="90" /> Voltar
            </Button>
        </div>
        <div class="col-10 my-4">
            <h3 class="c-ndarkthree">
                <span class="bold">{{ groupName | formatName }}</span> | Regras da operação
            </h3>
        </div>
        <div class="col-10">
            <el-steps direction="vertical" :active="activeStep" finish-status="success">
                <el-step title="Selecionar produtos de crédito">
                    <div class="col-8 mt-5 pl-0" slot="description" v-if="activeStep == 0">
                        <div class="d-flex mt-4 mb-4">
                            <!-- <el-checkbox v-model="groupRules.availableToFomentation" :class="getPrimaryColor"><span class="medium">Fomento à produção</span></el-checkbox> -->
                            <el-checkbox v-model="groupRules.availableToMarketplace" :class="getPrimaryColor" @change="handleMarketplaceSelection" :disabled="groupRules.availableToInvoiceDeadlineExtension">
                                <span class="medium">
                                    Antecipação de recebíveis
                                </span>
                            </el-checkbox>

                            <el-checkbox v-model="groupRules.availableToInvoiceDeadlineExtension" :class="getPrimaryColor" @change="handleDeadlineExtensionSelection" :disabled="groupRules.availableToMarketplace">
                                <span class="medium">
                                    Alongamento de prazo
                                </span>
                            </el-checkbox>
                        </div>
                        <div class="mb-4" v-if="activeStep == 0 || !groupRules.availableToMarketplace">
                            <router-link to="" @click.native="$router.go(-1)" :class="getPrimaryColor">Voltar</router-link>
                            <Button :color="getPrimaryColor" :disabled="!groupRules.availableToMarketplace && !groupRules.availableToInvoiceDeadlineExtension" class="ml-3" @click="activeStep++">Continuar</Button>
                        </div>
                    </div>
                </el-step>
                <el-step :title="`Definir regras de ${groupRules.availableToMarketplace ?  'antecipação de recebíveis' : 'alongamento de prazo'}`" :status="!USER_TYPE_MIXIN.isBackOffice ? 'process' : 'wait'" v-if="groupRules.availableToInvoiceDeadlineExtension || groupRules.availableToMarketplace">
                    <div class="col-10 mt-4 pl-0" slot="description" v-if="activeStep == 1">
                        <!-- <InputRadio label="Modelo de financiamento" :model="radio" :items="[{label: 'Todos os financiadores', value: 0}, {label: 'Capital próprio', value: 1}, {label: 'Apenas alguns financiadores', value: 2}]"/> -->
                        <!-- <div v-if="groupRules.availableToMarketplace == true">
                            <p class="c-nmidthree bold mb-3">Qual o modelo de financiamento?</p>
                            <el-radio-group v-model="groupRules.orderAntecipationMode">
                                <el-radio :class="getPrimaryColor" label="marketplace">Todos os financiadores</el-radio>
                                <el-radio :class="getPrimaryColor" label="own" v-if="!USER_TYPE_MIXIN.isBackOffice">Capital próprio</el-radio>
                                <el-radio :class="getPrimaryColor" label="selected">Apenas alguns financiadores</el-radio>
                            </el-radio-group>
                        </div> -->
                        <div v-if="groupRules.availableToMarketplace == true">
                            <p class="c-ndarkfour bold mb-3">Qual o modelo de financiamento?</p>
                            <el-radio-group v-model="groupRules.orderAntecipationMode">
                                <el-radio :class="getPrimaryColor" label="marketplace">Todos financiadores exclusivos</el-radio>
                                <el-radio :class="getPrimaryColor" label="selected">Selecionar financiadores exclusivos</el-radio>
                            </el-radio-group>
                        </div>
                        <div class="row mt-2 px-0">
                            <div class="col-12 mt-3" v-if="groupRules.orderAntecipationMode =='selected'" >
                                <SponsorGroup :tableData="sponsorGroupData" @change="selection = $event" :singleSelection="groupRules.availableToInvoiceDeadlineExtension"/>
                            </div>
                            <div class="col-12 mt-3 pt-3" v-if="groupRules.orderAntecipationMode != 'own' && groupRules.availableToMarketplace">
                                <p class="c-ndarkfour bold mb-3">O fornecedor precisa anexar o arquivo XML?</p>
                                <el-radio-group v-model="groupRules.xmlRequiredForAnticipation">
                                    <el-radio :class="getPrimaryColor" :label="true">Sim</el-radio>
                                    <el-radio :class="getPrimaryColor" :label="false">Não</el-radio>
                                </el-radio-group>
                            </div>
                            <div class="col-12 mt-3 pt-3" v-if="groupRules.xmlRequiredForAnticipation && groupRules.orderAntecipationMode != 'own' && groupRules.availableToMarketplace">
                                <p class="c-ndarkfour bold mb-3">Quais os tipos de nota é obrigatório o cedente anexar?</p>
                                <el-checkbox-group v-model="groupRules.orderTypeRequiresXmlOrPdf" class="d-flex">
                                    <el-checkbox :class="getPrimaryColor" key="1" label="1" value="1" class="mr-4">
                                        NFe
                                    </el-checkbox>
                                    <el-checkbox :class="getPrimaryColor" key="2" label="2" value="2" class="mr-4">
                                        NFSe
                                    </el-checkbox>
                                    <el-checkbox :class="getPrimaryColor" key="4" label="4" value="4">
                                        CTe
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="col-12 mt-3 pt-3" v-if="USER_TYPE_MIXIN.isAdm && groupRules.orderAntecipationMode != 'own' && groupRules.availableToMarketplace">
                                <p class="bold mb-3 c-ndarkfour">Enviar automaticamente as notas para antecipação?</p>
                                <el-radio-group v-model="groupRules.autoSendToMkt">
                                    <el-radio :class="getPrimaryColor" :label="true">Sim</el-radio>
                                    <el-radio :class="getPrimaryColor" :label="false">Não</el-radio>
                                </el-radio-group>
                            </div>

                            <div class="col-12 mt-3 pt-3" v-if="groupRules.orderAntecipationMode != 'own' && groupRules.availableToMarketplace" >
                                <p class="c-ndarkfour bold mb-3">
                                    Em qual status a nota pode ir para <span>{{ getWhiteLabel !== 'CASHFORCE' ? 'negociação' : 'o marketplace'}}</span>?
                                </p>
                                <el-radio-group v-model="groupRules.orderStatusAllowedToMarketplace">
                                    <el-radio :class="getPrimaryColor" :label="3">Nota fiscal vinculada</el-radio>
                                    <el-radio :class="getPrimaryColor" :label="5">Pagamento autorizado</el-radio>
                                </el-radio-group>
                            </div>

                            <!-- <div class="col-12 mt-4" v-if="groupRules.orderAntecipationMode != 'own'">
                                <p class="c-ndarkfour bold mb-3">Confirma a mercadoria?</p>
                                <el-radio-group v-model="groupRules.confirmMerchandise">
                                    <el-radio :class="getPrimaryColor" :label="true">Sim</el-radio>
                                    <el-radio :class="getPrimaryColor" :label="false">Não</el-radio>
                                </el-radio-group>
                            </div> -->

                            <!-- <div class="col-4 mt-4" v-if="groupRules.orderAntecipationMode != 'own'">
                                <p class="c-ndarkfour bold mb-3">Cashback das operações</p>
                                <label>Cashback (%)</label>
                                <Money class="input-money" v-model="groupRules.cashbackOperation" v-bind="numberFloat" />
                            </div> -->

                            <div class="col-12 mt-3 pt-3" v-if="groupRules.orderAntecipationMode != 'own' && groupRules.availableToInvoiceDeadlineExtension">
                                <p class="c-ndarkfour bold mb-3">Qual é a taxa de juros?</p>
                                <Money class="input-money col-4" v-model="groupRules.interestRatePerMonth" v-bind="percentageNumber" />

                            </div>

                            <div class="col-12 mt-3 pt-3" v-if="groupRules.orderAntecipationMode != 'own' && groupRules.availableToInvoiceDeadlineExtension">
                                <p class="c-ndarkfour bold mb-3">Qual é o prazo adicional?</p>
                                <el-input class="w-33" :class="getPrimaryColor" v-model="groupRules.extendedDeadlineDays" placeholder="60 dias" v-money="daysNumber" />
                            </div>

                            <div class="col-12 mt-5 mb-4">
                                <router-link :class="`${getPrimaryColor} c-ndarkfour`" to="" @click.native="activeStep--">Voltar</router-link>
                                <Button :color="getPrimaryColor" class="ml-3" :disabled="groupRules.orderAntecipationMode =='selected' && !selection.length" @click="insertGroupRules">Finalizar</Button>
                            </div>

                        </div>
                    </div>
                    <div class="col-8">
                    </div>
                </el-step>
            </el-steps>
        </div>
    </div>
    <FullLoading :color="getPrimaryColorHex.five" v-if="$store.state.user.loading"/>
</div>
</template>

<script>
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import SponsorGroup from '@/components/tables/SponsorGroup'
import getSponsorsEconomicGroup from '@/api/getSponsorsEconomicGroup'
import getEconomicGroupSponsors from '@/api/getEconomicGroupSponsors'
import getEconomicGroupProviderSponsors from '@/api/getEconomicGroupProviderSponsors'
import getEconomicGroupRules from '@/api/getEconomicGroupRules'
import getEconomicGroupRulesProvider from '@/api/getEconomicGroupRulesProvider'
import insertEconomicGroupRulesProvider from '@/api/insertEconomicGroupRulesProvider'
import updateEconomicGroupRulesProvider from '@/api/updateEconomicGroupRulesProvider'
import FullLoading from '@/components/loading/FullLoading'
import insertProviderSponsorsEconomicGroup from '@/api/insertProviderSponsorsEconomicGroup'
import deleteProviderSponsorsEconomicGroup from '@/api/deleteProviderSponsorsEconomicGroup'
import getEconomicGroup from '@/api/getEconomicGroup'
//import removeMask from '@/utils/removeMask'
import { Money } from 'v-money'
export default {
    components: {
        ArrowDropdown,
        SponsorGroup,
        FullLoading,
        Money
    },
    data() {
        return {
            numberFloat: {
                decimal: ',',
                thousands: '.',
                precision: 2,
                suffix: '%',
                masked: false
            },
            daysNumber: {
                suffix: 'dias',
                masked: false,
            },
            percentageNumber: {
                decimal: ',',
                thousands: '.',
                precision: 2,
                suffix: '%',
                masked: false
            },
            groupRules: {
                availableToMarketplace: false,
                availableToFomentation: false,
                orderAntecipationMode: 'marketplace',
                confirmMerchandise: true,
                cashbackOperation: '',
                providerAllowedSendOrderToMarket: '',
                orderStatusAllowedToMarketplace: '',
                buyerSendXml: false,
                autoSendToMkt: false,
                providerId: parseInt(this.$route.params.providerId),
                xmlRequiredForAnticipation: true,
                availableToInvoiceDeadlineExtension: false,
                interestRatePerMonth: 0,
                extendedDeadlineDays: 60,
                orderTypeRequiresXmlOrPdf: [],
                
            },
            activeStep: 0,
            selection: [],
            sponsorGroupData: [],
            sponsorIdsToDelete: [],
            registeredRulesProvider: false,
            group: {},
        }
    },
    computed: {
        groupName() {
            return this.group.name
        }
    },
    watch: {
        'groupRules.buyerSendXml': function (withXml) {
            if (withXml == false) {
                this.groupRules.providerAllowedSendOrderToMarket = true
            }
        },
        'groupRules.xmlRequiredForAnticipation': function (data) {
            if (data == false) {
                this.groupRules.orderTypeRequiresXmlOrPdf = []
            }
        },
    },
    methods: {
        async insertGroupRules() {
            /*             const unmaskedGroupRules = {
                            ...this.groupRules,
                            cashbackOperation: removeMask(this.groupRules.cashbackOperation / 100)
                        } */
            const result = this.registeredRulesProvider
                ? await updateEconomicGroupRulesProvider(this.$route.params.groupId, {
                    ...this.groupRules,                    
                    cashbackOperation: this.groupRules.cashbackOperation / 100
                })
                : await insertEconomicGroupRulesProvider(this.$route.params.groupId, {
                    ...this.groupRules,
                    cashbackOperation: this.groupRules.cashbackOperation / 100
                })
            /* const result = await updateEconomicGroupRules(this.$route.params.groupId, {
                ...this.groupRules,
                cashbackOperation: this.groupRules.cashbackOperation / 100
            }) */
            if (this.groupRules.orderAntecipationMode == 'selected') {
                await deleteProviderSponsorsEconomicGroup(this.$route.params.groupId, {
                    providerId: this.$route.params.providerId,
                    sponsorIds: this.sponsorIdsToDelete
                })
                await insertProviderSponsorsEconomicGroup(this.$route.params.groupId, {
                    providerId: this.$route.params.providerId,
                    sponsorIds: this.selection
                })
            }
            if (this.groupRules.orderAntecipationMode == 'marketplace') {
                await deleteProviderSponsorsEconomicGroup(this.$route.params.groupId, {
                    providerId: this.$route.params.providerId,
                    sponsorIds: this.sponsorIdsToDelete
                })
            }
            if (result.data.ok) {
                const notifyTitle = this.registeredRulesProvider ? 'Alterações salvas com sucesso!' : 'Regras da operação criadas com sucesso!'
                this.$notify({
                    title: notifyTitle,
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                });
                this.$router.go(-1)
            } else {
                this.$notify({
                    title: 'Opa! Encontramos algum erro.',
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                });
            }
        },
        updateRulesByDeadlineExtensionSelection() {
            this.groupRules.orderAntecipationMode = 'selected'
            this.groupRules.autoSendToMkt = false
            this.groupRules.orderStatusAllowedToMarketplace = '5'
            this.groupRules.xmlRequiredForAnticipation = false
        },
        handleDeadlineExtensionSelection(updatedValue) {
            if (updatedValue == 1) {
                this.groupRules.availableToMarketplace = false
                this.updateRulesByDeadlineExtensionSelection()
            }
        },
        handleMarketplaceSelection(updatedValue) {
            if (updatedValue == 1) {
                this.groupRules.availableToInvoiceDeadlineExtension = false

            }
        }
    },
    async created() {
        const { groupId, providerId } = this.$route.params

        const [result, resultRules, resultAssociatedSponsors, resultProviderAssociatedSponsors, resultRulesProvider, group ] = await Promise.all([
            getSponsorsEconomicGroup(),
            getEconomicGroupRules(groupId),
            getEconomicGroupSponsors(groupId),
            getEconomicGroupProviderSponsors(groupId, providerId),
            getEconomicGroupRulesProvider(groupId, providerId),
            getEconomicGroup(groupId)
        ])
        this.group = group?.data?.payload || {}
        if (result.data.ok) this.sponsorGroupData = result.data.payload
        if (resultRules.data.ok) {
            if (resultRules.data.payload != null) {
                const {
                    orderAntecipationMode,
                    cashbackOperation,
                    confirmMerchandise,
                    buyerSendXml,
                    providerAllowedSendOrderToMarket,
                    orderStatusAllowedToMarketplace,
                    daysAllowedSendOrderToMarket,
                    autoSendToMkt,
                    xmlRequiredForAnticipation,
                    availableToInvoiceDeadlineExtension,
                    interestRatePerMonth,
                    extendedDeadlineDays,
                    orderTypeRequiresXmlOrPdf,
                } = resultRules.data.payload
                this.groupRules = {
                    ...this.groupRules,
                    orderAntecipationMode,
                    cashbackOperation: cashbackOperation * 100,
                    confirmMerchandise,
                    buyerSendXml,
                    providerAllowedSendOrderToMarket,
                    orderStatusAllowedToMarketplace,
                    daysAllowedSendOrderToMarket,
                    autoSendToMkt,
                    xmlRequiredForAnticipation,
                    availableToInvoiceDeadlineExtension,
                    interestRatePerMonth,
                    extendedDeadlineDays,
                    orderTypeRequiresXmlOrPdf: orderTypeRequiresXmlOrPdf || []
                }
            }
        }
        if (resultAssociatedSponsors.data.ok) {
            // this.$store.commit('group/setSelectedSponsors', resultAssociatedSponsors.data.payload)
            // if (resultAssociatedSponsors.data.payload != null) {
            //     this.sponsorIdsToDelete = resultAssociatedSponsors.data.payload.map(sponsor => sponsor.id)
            // }
        }
        if (resultProviderAssociatedSponsors.data.ok) {
            this.$store.commit('group/setSelectedSponsors', resultProviderAssociatedSponsors.data.payload.map(association => ({ id: association.sponsorId })))
            if (resultProviderAssociatedSponsors.data.payload != null) {
                this.sponsorIdsToDelete = resultProviderAssociatedSponsors.data.payload.map(association => association.sponsorId)
            }
        }
        if (resultRulesProvider.data.ok) {
            if (resultRulesProvider.data.payload == null) {
                this.registeredRulesProvider = false
            } else {
                this.registeredRulesProvider = true
                const rulesProvider = resultRulesProvider.data.payload
                this.activeStep = !rulesProvider.availableToMarketplace ? 0 : 1
                this.groupRules = {
                    ...this.groupRules,
                    orderAntecipationMode: rulesProvider.orderAntecipationMode != null ? rulesProvider.orderAntecipationMode : this.groupRules.orderAntecipationMode,
                    availableToMarketplace: rulesProvider.availableToMarketplace,
                    availableToFomentation: rulesProvider.availableToFomentation,
                    availableToInvoiceDeadlineExtension: rulesProvider.availableToInvoiceDeadlineExtension,
                    //confirmMerchandise,
                    //cashbackOperation: cashbackOperation * 100,
                    providerAllowedSendOrderToMarket: rulesProvider.providerAllowedSendOrderToMarket != null ? rulesProvider.providerAllowedSendOrderToMarket : this.groupRules.providerAllowedSendOrderToMarket,
                    orderStatusAllowedToMarketplace: rulesProvider.orderStatusAllowedToMarketplace != 0 ? rulesProvider.orderStatusAllowedToMarketplace : this.groupRules.orderStatusAllowedToMarketplace,
                    daysAllowedSendOrderToMarket: rulesProvider.daysAllowedSendOrderToMarket != 0 ? rulesProvider.daysAllowedSendOrderToMarket : this.groupRules.daysAllowedSendOrderToMarket,
                    autoSendToMkt: rulesProvider.autoSendToMkt != null ? rulesProvider.autoSendToMkt : this.groupRules.autoSendToMkt,
                    interestRatePerMonth: rulesProvider.interestRatePerMonth || this.groupRules.interestRatePerMonth,
                    extendedDeadlineDays: rulesProvider.extendedDeadlineDays,
                    orderTypeRequiresXmlOrPdf: rulesProvider.orderTypeRequiresXmlOrPdf || [],
                    xmlRequiredForAnticipation: rulesProvider.xmlRequiredForAnticipation,
                    //buyerSendXml
                }
            }
        }
        if (this.USER_TYPE_MIXIN.isBackOffice) {
            this.groupRules.availableToMarketplace = true
            this.activeStep = 1
        }
    },
    destroyed() {
        this.$store.commit('group/setSelectedSponsors', [])
    }

}
</script>

<style lang="scss" scoped>
.w-33 {
    width: 33.3333%
}
</style>
